// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line[data-v-458ae8a5]{padding-bottom:10px;padding-top:0;white-space:nowrap;overflow:hidden;font-size:12px}.bold[data-v-458ae8a5]{font-weight:700;color:#00475a}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
